import { http } from "../../utils/config";

const logMessageAPI = {
  getHistories: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = "",
      type = "",
      event = "",
      send_status = "",
      from_date = "",
      to_date = "",
      sort_by = "created_at",
      sort_order = "desc",
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
    });
    if (search) queryParams.set("search", search);
    if (type) queryParams.set("type", type);
    if (event) queryParams.set("event", event);
    if (send_status) queryParams.set("send_status", send_status);
    if (from_date) queryParams.set("from_date", from_date);
    if (to_date) queryParams.set("to_date", to_date);

    return http.get(`/api/v1/logs/histories?${queryParams}`);
  },

  // Gửi lại 1 tin (chỉ áp dụng cho tin thất bại)
  resend: (id) => http.post(`/api/v1/logs/histories/${id}/resend`),
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error("API Error:", error);

      // Handle different types of errors
      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 401:
            throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
          case 403:
            throw new Error("Bạn không có quyền thực hiện thao tác này");
          case 404:
            throw new Error("Không tìm thấy thông tin");
          case 422:
            throw new Error(data.message || "Dữ liệu không hợp lệ");
          case 500:
            // throw new Error("Lỗi server, vui lòng thử lại sau");
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || "Đã có lỗi xảy ra");
        }
      } else if (error.request) {
        // Network error
        throw new Error("Không thể kết nối đến server");
      } else {
        // Other error
        throw new Error(error.message || "Đã có lỗi xảy ra");
      }
    }
  };
};

// Wrapped API functions with error handling
export const logMessageAPIWithErrorHandling = {
  getHistories: withErrorHandling(logMessageAPI.getHistories),
  resend: withErrorHandling(logMessageAPI.resend),
};

export default logMessageAPI;
